import script from "./PersonSetModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonSetModal.vue?vue&type=script&lang=ts&setup=true"

import "./PersonSetModal.vue?vue&type=style&index=0&id=14fedd08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fedd08"]])

export default __exports__